<template>
  <el-dialog
    title="选择订单"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <!-- 这里放置订单选择的内容 -->
    <el-table
      :data="orderList"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
      <el-table-column prop="personName" label="用户" align="center"></el-table-column>
      <el-table-column prop="totalPrice" label="总金额" align="center"></el-table-column>
      <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
      <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
    </el-table>

    <el-pagination
      class="pagination-container"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSelection">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ChooseStoreOrder',
  data() {
    return {
      dialogVisible: false,
      orderList: [],
      selectedOrders: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      console.log(this.pageSize)
      // 这里可以添加获取订单列表的逻辑
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleSelectionChange(val) {
      this.selectedOrders = val
    },
    confirmSelection() {
      if (this.selectedOrders.length === 0) {
        this.$message.warning('请至少选择一条订单')
        return
      }
      this.$emit('chooseStoreOrder', this.selectedOrders[0])
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 这里可以添加分页请求数据的逻辑
    }
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>